import React from "react";
import { get } from "lodash";
import Icon from "@irati/ui/src/Icon";
import getProductDetails from "@irati/products/utils/getProductDetails";
import { connect } from "@irati/store";
import mainTheme from "@irati/ui/src/global/theme";
import { injectIntl } from "@irati/utils/lang";
import IconTypes from "@irati/ui/src/Icon/IconTypes.enum";
import { ProductCard, ProductContent, ProductLogo, ResponsiveBody, ResponsiveH3 } from "./styled";
import TenantProductLink from "./TenantProductLink";
var TenantProduct = function (_a) {
    var formatMessage = _a.formatMessage, isLast = _a.isLast, product = _a.product;
    var productDetails = getProductDetails(formatMessage);
    var p = productDetails[product.product];
    if (!p) {
        return null;
    }
    return (React.createElement(TenantProductLink, { cardId: product.product, product: product, to: "/", trackingName: product.trackingName },
        React.createElement(ProductCard, { isActive: product.active, isLast: isLast },
            React.createElement(ProductLogo, { backgroundColor: p.color },
                React.createElement(Icon, { color: mainTheme.colors.utility.white, icon: p.icon, size: 32 })),
            React.createElement(ProductContent, null,
                React.createElement("div", null,
                    React.createElement(ResponsiveH3, null, p.title),
                    React.createElement(ResponsiveBody, null, p.text)),
                React.createElement(Icon, { icon: IconTypes.chevronRight })))));
};
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({
        isMobile: get(mq, "lessThan.medium", false),
        isTablet: get(mq, "lessThan.large", false)
    });
};
export default injectIntl(connect(mapStateToProps)(TenantProduct));
